if (!customElements.get("m-rotated-products-slider")) {
  class MRotatedProductsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const cards = this.querySelectorAll(".m-rotated-products__card");
      cards.forEach((card) => {
        card.addEventListener("click", (e) => {
          // If wishlist button clicked, toggle active and don't navigate
          const wishlistBtn = e.target.closest(".m-rotated-products__wishlist");
          if (wishlistBtn) {
            e.preventDefault();
            e.stopPropagation();
            wishlistBtn.classList.toggle("is-active");
            return false;
          }
        });
      });
    }
  }

  customElements.define("m-rotated-products-slider", MRotatedProductsSlider);
}
